// import i18n from './i18n';

// export function Translate(key: string, def: string) {
//   return i18n.t(key) === key ? def : i18n.t(key);
// }
export function FirstUpperCase(data: string) {
  return (
    data.toLocaleLowerCase().charAt(0).toLocaleUpperCase() +
    data.toLocaleLowerCase().slice(1)
  );
}
export function TranslateUnit(
  key: string,
  def: string,
  num: number,
  lang: number
) {

  // let tmp = i18n.t(key) === key ? def : i18n.t(key);
  let tmp = def;
  let vowel = ['u','e','o','a','i'];
  if(num <= 1){
      return tmp;
  }
  if(tmp !== def){
    if (lang === 1) {
        let oneCharLast = '';
        let twoCharLast = '';
        if (tmp.length > 1) {
          oneCharLast = tmp.slice(-1).toLocaleLowerCase();
        }
        if (tmp.length > 2) {
          twoCharLast = tmp.slice(-2).toLocaleLowerCase();
        }
        if (oneCharLast !== '') {
          switch (oneCharLast) {
            case 's': {
                tmp= tmp+"es";
                return tmp;
            }
            case 'x': {
                tmp= tmp+"es";
                return tmp;
            }
            case 'z': {
                tmp= tmp+"zes";
                return tmp;
            }
            case 'f': {
                tmp= tmp.slice(0,tmp.length-2);
                tmp= tmp+ "ves";
                return tmp;
            }
            default:{
                break;
            }
          }
        }
        if (twoCharLast !== '') {
            switch (twoCharLast) {
              case 'ch': {
                  tmp= tmp+"es";
                  return tmp;
              }
              case 'sh': {
                  tmp= tmp+"es";
                  return tmp;
              }
              case 'fe': {
                tmp= tmp.slice(0,tmp.length-3);
                tmp= tmp+ "ves";
                  return tmp;
              }
              case 'ff': {
                  tmp= tmp.slice(0,tmp.length-3);
                  tmp= tmp+ "ves";
                  return tmp;
              }
              case 'ye': {
                tmp= tmp+ "s";
                return tmp;
            }
              default:{
                  break;
              }
            }
            switch (oneCharLast) {
                  case 'o': {
                      let firstChar= twoCharLast[0];
                      if(!vowel.find(c=>c === firstChar))
                      {
                        tmp= tmp+"es";
                      }
                      return tmp;
                  }
                  case 'y': {
                    let firstChar= twoCharLast[0];
                    if(!vowel.find(c=>c === firstChar))
                    {
                        tmp= tmp.slice(0,tmp.length-2);
                        tmp= tmp+ "ves";
                    }
                    return tmp;
                  }
                  default:{
                      break;
                  }
                }
          }
          return tmp+"s";
      }
      return tmp;
  }
  return tmp;
}
